import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useLeadsData = (fetchCaseManagers = true) => {
  const nav = useNavigate();
  const [leads, setLeads] = useState(null);
  const [stats, setStats] = useState({ total: 0, new: 0, contacted: 0, funded: 0 });
  const [caseManagers, setCaseManagers] = useState([]);

  const load = useCallback(async () => {
    try {
      const [l, s] = await Promise.all([
        axios.get(`${API}/leads`, { withCredentials: true }),
        axios.get(`${API}/leads/stats`, { withCredentials: true }),
      ]);
      setLeads(l.data);
      setStats(s.data);
    } catch (e) {
      if (e.response?.status === 401) nav("/admin/login");
      return;
    }
    if (!fetchCaseManagers) return;
    try {
      const c = await axios.get(`${API}/case-managers`, { withCredentials: true });
      setCaseManagers(c.data);
    } catch {
      setCaseManagers([]);
    }
  }, [nav, fetchCaseManagers]);

  useEffect(() => {
    load();
  }, [load]);

  const logout = useCallback(async () => {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    nav("/admin/login");
  }, [nav]);

  const exportCsv = useCallback(async () => {
    const res = await axios.get(`${API}/leads/export`, { withCredentials: true, responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `growth-funds-leads-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }, []);

  const changeStatus = useCallback(async (id, status) => {
    await axios.patch(`${API}/leads/${id}/status`, { status }, { withCredentials: true });
    load();
  }, [load]);

  const changeCaseManager = useCallback(async (id, caseManager) => {
    await axios.patch(`${API}/leads/${id}/case-manager`, { case_manager: caseManager }, { withCredentials: true });
    load();
  }, [load]);

  return { leads, stats, caseManagers, setCaseManagers, load, logout, exportCsv, changeStatus, changeCaseManager };
};
